import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import AuteursSearch from '../components/AuteursSearch.vue'
import emitter from '../utils/emitter';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const dates = JSON.parse(this.el.dataset.dates);

        const app = createApp({
            template: '<AuteursSearch :dates="dates" />',
            components: {
                AuteursSearch
            },
            data() {
                return {
                    dates: dates
                }
            },
            mounted() {
            },
        })
        app.config.globalProperties.modular = self;
        app.config.globalProperties.emitter = emitter;
        app.mount(self.el)
    }
}